var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-w-screen min-h-screen bg-gray-50 flex items-center justify-center px-3 py-5"},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }